export default {
    name: 'ProductList',
    render() {
        return(
          <h1>Products catalog</h1>
        )
    }
}